import { render, staticRenderFns } from "./OTCTra.vue?vue&type=template&id=5cb38776&scoped=true&"
var script = {}
import style0 from "./OTCTra.vue?vue&type=style&index=0&id=5cb38776&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb38776",
  null
  
)

export default component.exports